import React from 'react';

import './global.css';

import Routes from './routes';

function App() { //JSX (JavaScript XML)
  return ( 
      <Routes />
  );
}

export default App;
